// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductGenericInformation_container__QRlgg","header":"ProductGenericInformation_header__AOJc6","description":"ProductGenericInformation_description__J1nLO"};